// {{WORKTREE_ROOT}}/picosponsorconsole/app/components/common/CsrfInput.tsx
// PLAN2 WP10 — every posting form renders this hidden field (the CSRF guard, §9).
import { useCsrfToken } from "~/hooks/useActionFetcher";
export function CsrfInput() { return <input type="hidden" name="csrf" value={useCsrfToken()} />; }
